import { type JSX } from 'react';

import type { DropdownSection } from '../types';
import LayeredMenuItem from './LayeredMenuItem';

interface LayeredMenuProps {
    sections: DropdownSection[];
}

export default function LayeredMenu({ sections }: LayeredMenuProps): JSX.Element {
    return (
        <div className="flex flex-col p-8 gap-4">
            {sections.map((section, index) => {
                const hasTitle = !!section.title;
                return (
                    <div key={section.title || `section-${index}`}>
                        {/* Section header + divider — only when the section has a title.
                            Headerless sections (e.g. AI Tools) skip this so the dropdown
                            trigger label isn't repeated inside the panel. */}
                        {hasTitle && (
                            <div className="flex flex-col gap-2 pt-4 first:pt-0">
                                <span className="pb-2 text-sm text-gray-900">{section.title}</span>
                                <div className="h-px bg-gray-200" />
                            </div>
                        )}

                        {/* Section items */}
                        <div className={`flex flex-col gap-4 ${hasTitle ? 'pt-4' : ''}`}>
                            {section.items.map((item) => (
                                <LayeredMenuItem key={item.href} item={item} />
                            ))}
                        </div>
                    </div>
                );
            })}
        </div>
    );
}
